import type { WorkplacePickerValue } from "./WorkplacePicker";

/** Empty starting value for parents binding WorkplacePicker.
 *  Lives in its own file because eslint's react-refresh rule
 *  refuses non-component exports next to component definitions. */
export const EMPTY_WORKPLACE: WorkplacePickerValue = {
  kind: null,
  id: "",
  labels: { partner: null, organization: null, location: null },
};
